<template>
  <b-button
    :variant="variant"
    class="min-w-60px"
    @click="$emit('click')"
  >
    <slot />

    <span v-if="loading" class="loading-spinner ml-1" />
  </b-button>
</template>

<script>
export default {
  props: {
    variant: {
      type: String,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
